const AdminLoginPage = () => import(/* webpackChunkName: "AdminLoginPage" */ '../admin/AdminLoginPage.vue');
// import AdminLoginPage from '../admin/AdminLoginPage.vue';
const AdminMenuPage = () => import(/* webpackChunkName: "AdminMenuPage" */ '../admin/menu/AdminMenuPage.vue');
// import AdminMenuPage from '../admin/menu/AdminMenuPage.vue';
const StudentsListPage = () => import(/* webpackChunkName: "StudentsListPage" */ '../admin/students_list/StudentsListPage.vue');
// import StudentsListPage from '../admin/students_list/StudentsListPage.vue';
const AdminMasterPage = () => import(/* webpackChunkName: "AdminMasterPage" */ '../admin/master/AdminMasterPage.vue');
// import AdminMasterPage from '../admin/master/AdminMasterPage.vue';

const EventNewsAdminPage = () => import(/* webpackChunkName: "EventNewsAdminPage" */ '../admin/master/EventNewsAdminPage.vue');
// import EventNewsAdminPage from '../admin/master/EventNewsAdminPage.vue';
const DaCalendarPage = () => import(/* webpackChunkName: "DaCalendarPage" */ '../admin/deafacademy_calendar/DaCalendarPage.vue');
// import DaCalendarPage from '../admin/deafacademy_calendar/DaCalendarPage.vue';
const SupportPlanPage = () => import(/* webpackChunkName: "SupportPlanPage" */ '../admin/support_plan/SupportPlanPage.vue');
// import SupportPlanPage from '../admin/support_plan/SupportPlanPage.vue';
const DaSupportPlanPage = () => import(/* webpackChunkName: "DaSupportPlanPage" */ '../admin/support_plan/DaSupportPlanPage.vue');
// import DaSupportPlanPage from '../admin/support_plan/DaSupportPlanPage.vue';

const TeachersListPage = () => import(/* webpackChunkName: "TeachersListPage" */ '../admin/teachers_list/TeachersListPage.vue');
// import TeachersListPage from '../admin/teachers_list/TeachersListPage.vue';
const TeacherSelectionListPage = () => import(/* webpackChunkName: "TeacherSelectionListPage" */ '../admin/teachers_list/TeacherSelectionListPage.vue');
// import TeacherSelectionListPage from '../admin/teachers_list/TeacherSelectionListPage.vue';
const TeacherFailuerListPage = () => import(/* webpackChunkName: "TeacherFailuerListPage" */ '../admin/teachers_list/TeacherFailuerListPage.vue');
// import TeacherFailuerListPage from '../admin/teachers_list/TeacherFailuerListPage.vue';
const AdminDailyReportPage = () => import(/* webpackChunkName: "AdminDailyReportPage" */ '../admin/report/AdminDailyReportPage.vue');
// import AdminDailyReportPage from '../admin/report/AdminDailyReportPage.vue';
const AdminShowLessonsPage = () => import(/* webpackChunkName: "AdminShowLessonsPage" */ '../admin/report/AdminShowLessonsPage.vue');
// import AdminShowLessonsPage from '../admin/report/AdminShowLessonsPage.vue';
const MatchingListPage = () => import(/* webpackChunkName: "MatchingListPage" */ '../admin/matching/MatchingListPage.vue');
// import MatchingListPage from '../admin/matching/MatchingListPage.vue';

const PaymentTeacherPage = () => import(/* webpackChunkName: "PaymentTeacherPage" */ '../admin/payment/PaymentTeacherPage.vue');
// import PaymentTeacherPage from '../admin/payment/PaymentTeacherPage.vue';
const PaymentStudentPage = () => import(/* webpackChunkName: "PaymentStudentPage" */ '../admin/payment/PaymentStudentPage.vue');
// import PaymentStudentPage from '../admin/payment/PaymentStudentPage.vue';
const KaihipayUserCsvPage = () => import(/* webpackChunkName: "KaihipayUserCsvPage" */ '../admin/payment/KaihipayUserCsvPage.vue');

const TeacherBBSInAdminPage = () => import(/* webpackChunkName: "TeacherBBSInAdminPage" */ '../admin/bbs/TeacherBBSInAdminPage.vue');
// import TeacherBBSInAdminPage from '../admin/bbs/TeacherBBSInAdminPage.vue';
const AnalyticsPage = () => import(/* webpackChunkName: "AnalyticsPage" */ '../admin/analytics/AnalyticsPage.vue');
// import AnalyticsPage from '../admin/analytics/AnalyticsPage.vue';
const DaTeacherPage = () => import(/* webpackChunkName: "DaTeacherPage" */ '../admin/daefacademy_teacher/DaTeacherPage.vue');
// import DaTeacherPage from '../admin/daefacademy_teacher/DaTeacherPage.vue';
const CancelListPage = () => import(/* webpackChunkName: "CancelListPage" */ '../admin/students_list/CancelListPage.vue');
// import CancelListPage from '../admin/students_list/CancelListPage.vue';
const DaLessonReservationCommitPage = () => import(/* webpackChunkName: "DaLessonReservationCommitPage" */ '../admin/deafacademy_reservation_commit/DaLessonReservationCommitPage.vue');
// import DaLessonReservationCommitPage from '../admin/deafacademy_reservation_commit/DaLessonReservationCommitPage.vue';
const DaLessonReservationCommitCalendarPage = () =>
  import(/* webpackChunkName: "DaLessonReservationCommitCalendarPage" */ '../admin/deafacademy_reservation_commit/DaLessonReservationCommitCalendarPage.vue');
// import DaLessonReservationCommitCalendarPage from '../admin/deafacademy_reservation_commit/DaLessonReservationCommitCalendarPage.vue';
const DaAdminDailyReportPage = () => import(/* webpackChunkName: "DaAdminDailyReportPage" */ '../admin/report/DaAdminDailyReportPage.vue');
// import DaAdminDailyReportPage from '../admin/report/DaAdminDailyReportPage.vue';
const DaAdminDailyReportDocPage = () => import(/* webpackChunkName: "DaAdminDailyReportDocPage" */ '../admin/report/DaAdminDailyReportDocPage.vue');
// import DaAdminDailyReportDocPage from '../admin/report/DaAdminDailyReportDocPage.vue';
const SupportPlanPrintPage = () => import(/* webpackChunkName: "SupportPlanPrintPage" */ '../components/print/SupportPlanPrintPage.vue');
// import SupportPlanPrintPage from '../components/print/SupportPlanPrintPage.vue';
const MonitoringPrintPage = () => import(/* webpackChunkName: "MonitoringPrintPage" */ '../components/print/MonitoringPrintPage.vue');
// import MonitoringPrintPage from '../components/print/MonitoringPrintPage.vue';

const ReportPrintPage = () => import(/* webpackChunkName: "ReportPrintPage" */ '../components/print/ReportPrintPage.vue');
// import ReportPrintPage from '../components/print/ReportPrintPage.vue';
const AdminMessagePage = () => import(/* webpackChunkName: "AdminMessagePage" */ '../admin/message/AdminMessagePage.vue');
// import AdminMessagePage from '../admin/message/AdminMessagePage.vue';
const DaStudentsListPage = () => import(/* webpackChunkName: "DaStudentsListPage" */ '../admin/deafacademy_student/DaStudentsListPage.vue');
// import DaStudentsListPage from '../admin/deafacademy_student/DaStudentsListPage.vue';
const TestPage = () => import(/* webpackChunkName: "TestPage" */ '../admin/bbs/TestPage.vue');
// import TestPage from '../admin/bbs/TestPage.vue';
const ReportAnaliticsPage = () => import(/* webpackChunkName: "ReportAnaliticsPage" */ '../admin/analytics/ReportAnaliticsPage.vue');
// import ReportAnaliticsPage from '../admin/analytics/ReportAnaliticsPage.vue';
const PaymentOptionalPage = () => import(/* webpackChunkName: "PaymentOptionalPage" */ '../admin/payment/PaymentOptionalPage.vue');
// import PaymentOptionalPage from '../admin/payment/PaymentOptionalPage.vue';
const PaymentStudentToYuuchoPage = () => import(/* webpackChunkName: "PaymentStudentToYuuchoPage" */ '../admin/payment/PaymentStudentToYuuchoPage.vue');
// import PaymentStudentToYuuchoPage from '../admin/payment/PaymentStudentToYuuchoPage.vue';
const ResultReportListPage = () => import(/* webpackChunkName: "ResultReportListPage" */ '../admin/report/ResultReportListPage.vue');

export const adminRouters = [
  {
    path: '/admin-login-page',
    name: 'AdminLoginPage',
    component: AdminLoginPage,
  },
  {
    path: '/admin-menu-page',
    name: 'AdminMenuPage',
    component: AdminMenuPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teachers-list-page',
    name: 'TeachersListPage',
    component: TeachersListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-selection-list-page',
    name: 'TeacherSelectionListPage',
    component: TeacherSelectionListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-failuer-list-page',
    name: 'TeacherFailuerListPage',
    component: TeacherFailuerListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/students-list-page',
    name: 'StudentsListPage',
    component: StudentsListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/admin-master-page',
    name: 'AdminMasterPage',
    component: AdminMasterPage,
    meta: { requireAuth: true },
  },

  {
    path: '/da-calendar-page',
    name: 'DaCalendarPage',
    component: DaCalendarPage,
    meta: { requireAuth: true },
  },
  // {
  //   path: '/da-class-calendar-page',
  //   name: 'DaClassCalendarPage',
  //   component: DaClassCalendarPage,
  //   meta: { requireAuth: true },
  // },

  {
    path: '/da-teacher-page',
    name: 'DaTeacherPage',
    component: DaTeacherPage,
    meta: { requireAuth: true },
  },

  {
    path: '/EventNewsAdminPage',
    name: 'EventNewsAdminPage',
    component: EventNewsAdminPage,
    meta: { requireAuth: true },
  },
  {
    path: '/support-plan-page',
    name: 'SupportPlanPage',
    component: SupportPlanPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-support-plan-page',
    name: 'DaSupportPlanPage',
    component: DaSupportPlanPage,
    meta: { requireAuth: true },
  },

  {
    path: '/admin-daily-report-page',
    name: 'AdminDailyReportPage',
    component: AdminDailyReportPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-admin-daily-report-page',
    name: 'DaAdminDailyReportPage',
    component: DaAdminDailyReportPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-admin-daily-report-doc-page',
    name: 'DaAdminDailyReportDocPage',
    component: DaAdminDailyReportDocPage,
    meta: { requireAuth: true },
  },

  {
    path: '/admin-show-lessons-page',
    name: 'AdminShowLessonsPage',
    component: AdminShowLessonsPage,
    meta: { requireAuth: true },
  },
  {
    path: '/matching-list-page',
    name: 'MatchingListPage',
    component: MatchingListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/payment-student-page',
    name: 'PaymentStudentPage',
    component: PaymentStudentPage,
    meta: { requireAuth: true },
  },
  {
    path: '/payment-teacher-page',
    name: 'PaymentTeacherPage',
    component: PaymentTeacherPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher_bbs_in_admin_page',
    name: 'TeacherBBSInAdminPage',
    component: TeacherBBSInAdminPage,
    meta: { requireAuth: true },
  },
  {
    path: '/analytics-page',
    name: 'AnalyticsPage',
    component: AnalyticsPage,
    meta: { requireAuth: true },
  },
  {
    path: '/cancel-list-page',
    name: 'CancelListPage',
    component: CancelListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-lesson-reservation-commit-page',
    name: 'DaLessonReservationCommitPage',
    component: DaLessonReservationCommitPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-lesson-reservation-commit-calendar-page',
    name: 'DaLessonReservationCommitCalendarPage',
    component: DaLessonReservationCommitCalendarPage,
    meta: { requireAuth: true },
  },
  {
    path: '/test-page',
    name: 'TestPage',
    component: TestPage,
    meta: { requireAuth: true },
  },
  {
    path: '/support_plan_print_page',
    name: 'SupportPlanPrintPage',
    component: SupportPlanPrintPage,
    meta: { requireAuth: true },
  },
  {
    path: '/monitoring-print-page',
    name: 'MonitoringPrintPage',
    component: MonitoringPrintPage,
    meta: { requireAuth: true },
  },

  {
    path: '/report-print-page',
    name: 'ReportPrintPage',
    component: ReportPrintPage,
    meta: { requireAuth: true },
  },
  {
    path: '/admin-message-page',
    name: 'AdminMessagePage',
    component: AdminMessagePage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-students-list-page',
    name: 'DaStudentsListPage',
    component: DaStudentsListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/report-analitics-page',
    name: 'ReportAnaliticsPage',
    component: ReportAnaliticsPage,
    meta: { requireAuth: true },
  },
  {
    path: '/payment-optional-page',
    name: 'PaymentOptionalPage',
    component: PaymentOptionalPage,
    meta: { requireAuth: true },
  },
  {
    path: '/payment-student-to-yuucho-page',
    name: 'PaymentStudentToYuuchoPage',
    component: PaymentStudentToYuuchoPage,
    meta: { requireAuth: true },
  },
  {
    path: '/kaihipay-user-csv-page',
    name: 'KaihipayUserCsvPage',
    component: KaihipayUserCsvPage,
    meta: { requireAuth: true },
  },
  {
    path: '/result-report-list-page',
    name: 'ResultReportListPage',
    component: ResultReportListPage,
    meta: { requireAuth: true },
  },
].map((route) => {
  if (!route.meta) {
    (route as any).meta = {};
  }
  (route.meta as any).type = 'admin';
  return route;
});
